var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgYLetter = function SvgYLetter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 140 136"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#y-letter_svg__a)",
    d: "M139.322 0 86.374 84.556v36.564c0 9.917-4.969 14.88-14.895 14.88H51.956V84.376L.009 0h27.967c7.813 0 13.683 3.422 17.62 10.257l23.429 40.276 23.79-40.276C96.81 3.422 102.71 0 110.523 0z",
    className: "y-letter_svg__Vector"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "y-letter_svg__a",
    x1: -825.129,
    x2: 144.626,
    y1: -55.717,
    y2: 74.848,
    className: "y-letter_svg__a",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#983EBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#213DB5"
  })))));
};
export default SvgYLetter;